import { Controller } from "@hotwired/stimulus"
import { syncAll } from "../offline/sync"

// Monitors navigator.onLine, shows/hides offline banner, triggers sync on reconnect.
export default class extends Controller {
  connect() {
    this.onlineHandler = () => this.handleOnline()
    this.offlineHandler = () => this.handleOffline()

    window.addEventListener("online", this.onlineHandler)
    window.addEventListener("offline", this.offlineHandler)

    // Set initial state
    this.updateBanner(!navigator.onLine)
  }

  disconnect() {
    window.removeEventListener("online", this.onlineHandler)
    window.removeEventListener("offline", this.offlineHandler)
  }

  handleOnline() {
    this.updateBanner(false)
    document.dispatchEvent(new CustomEvent("toast:show", {
      detail: { message: "Back online! Syncing data...", type: "success" }
    }))
    // Trigger sync via service worker
    if (navigator.serviceWorker?.controller) {
      navigator.serviceWorker.controller.postMessage("sync-now")
    }
    // Also trigger client-side sync as fallback
    syncAll().catch(() => {})
  }

  handleOffline() {
    this.updateBanner(true)
    document.dispatchEvent(new CustomEvent("toast:show", {
      detail: { message: "You are offline. Changes will be saved locally.", type: "warning" }
    }))
  }

  updateBanner(show) {
    const banner = document.getElementById("offline-banner")
    if (banner) {
      banner.classList.toggle("hidden", !show)
    }
  }
}
